<template>
  <div
    class="regulatory-contract"
    v-loading="isLoading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <SiruiTable
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :columns="columnList"
        :height="'400px'"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="seq" title="序号" width="50" align="center"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'companyStatus'">{{
              row.companyStatus == 0 ? '已生效' : '已禁用'
            }}</template>
            <template v-else-if="item.field === 'departmentStatus'">{{
              row.departmentStatus == 0 ? '已生效' : '已禁用'
            }}</template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </SiruiTable>
    </div>
  </div>
</template>

<script>
  import { searchFormColumns, baseColumnListDefault } from './index.js';
  import organizationApi from '@/api/masterData/organization';
  import { filterEmpty } from '@/common/js/util.js';
  export default {
    name: 'SuperviseContractList',
    data() {
      return {
        tableData: [],
        multipleSelection: [], // 表格被选中的行数据
        checkRowKeys: [],
        menuButtonList: [], // 表格功能按钮
        query: {
          companyName: '',
          companyStatus: '',
          departmentName: '',
          departmentStatus: '',
        },
        columnList: baseColumnListDefault,
        loading: false,
        selectionList: [],
        isLoading: true,
      };
    },
    computed: {
      //表单字段
      searchColumns() {
        return searchFormColumns(this);
      },
    },
    mounted() {
      this.getTableData();
    },
    methods: {
      handleSelectionChange(row) {
        console.log(row, '选择行');
        this.selectionList = row;
      },
      dblclickEvent({ row }) {
        console.log(row);
      },
      // 搜索
      searchBtnClick() {
        this.getTableData();
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this.getTableData();
      },

      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      async getTableData() {
        this.isLoading = true;
        const postData = {
          ...filterEmpty(this.query),
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        const {
          data: { code, data },
        } = await this.$axios.post(organizationApi.GET_ORGANIZATION, postData);
        this.isLoading = false;
        if (code == 0) {
          this.$refs.siruiTable.setPageTotal(data.total);
          this.tableData = data.list;
        } else {
          this.$message.error('查询表格数据失败');
        }
      },
    },
  };
</script>
